import { monsterList } from "@/common/api/monster.js";
export default {
  namespaced: true,
  state: {
    info: {},
    packageList: [],
  },
  mutations: {
    // 当前宠物信息
    upDatePetInfo(state, info) {
      state.info = info;
    },
    // 宠物背包列表
    upDatePackageList(state, list) {
      // list.splice(0, 20);
      state.packageList = list || [];
    },
    // 更新宠物经验
    upDatePetExp(state, num) {
      let info = state.info;
      info.base_info.expr = num;
      state.info = info;
    },
    // 更新宠物名字
    upDatePetName(state, name) {
      let info = state.info;
      info.base_info.monster_name = name;
      state.info = info;
    },
  },
  actions: {
    upDatePetInfo({ commit }, data) {
      commit("upDatePetInfo", data);
    },
    async upDatePackageList({ commit }) {
      // 需要更新多个游戏的怪兽加成所有需要多次获取
      const gameIds = {
        合成大西瓜: 2,
        连连看: 1,
      };
      const fetchs = Object.values(gameIds).map((i) => {
        return monsterList({
          gid: i,
        });
      });
      let listData = await Promise.all(fetchs);
      listData = listData.reduce((accList, curList, curIndex) => {
        if (curList.status == 200) {
          if (Array.isArray(curList.data)) {
            if (accList.length == 0) {
              // 首次循环
              accList = curList.data.map((i) => {
                i.petRatio = {};
                i.petRatio[Object.values(gameIds)[curIndex]] =
                  i.play_quality_info;
                return i;
              });
            } else {
              accList = accList.map((i, index) => {
                i.petRatio[Object.values(gameIds)[curIndex]] =
                  curList.data[index].play_quality_info;
                return i;
              });
            }
          }
        }
        return accList;
      }, []);
      commit("upDatePackageList", listData);
    },
  },
  getters: {
    firstPetInfo(state) {
      return {
        monster_info: state.info,
        monster_level_up: false,
        monster_step_up: false,
        buy_status: false,
        user_level_up: false,
      };
    },
  },
};
